module.exports = __webpack_public_path__ + "static/media/미처분 이익잉여금 관리.95f7add2.png";